var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFuel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_33226",
    "data-name": "Path 33226",
    d: "M1,2A2,2,0,0,1,3,0H9a2,2,0,0,1,2,2v8a2,2,0,0,1,2,2v.5a.5.5,0,0,0,1,0V8h-.5a.5.5,0,0,1-.5-.5V4.375a.5.5,0,0,1,.5-.5h1.495a3.223,3.223,0,0,0-.2-1.222.97.97,0,0,0-.394-.458A1.731,1.731,0,0,0,13.5,2a.5.5,0,0,1,0-1,2.7,2.7,0,0,1,1.412.336,1.967,1.967,0,0,1,.794.907A5.186,5.186,0,0,1,16,4.324V7.5a.5.5,0,0,1-.5.5H15v4.5a1.5,1.5,0,1,1-3,0V12a1,1,0,0,0-1-1v4h.5a.5.5,0,0,1,0,1H.5a.5.5,0,0,1,0-1H1ZM3.5,2a.5.5,0,0,0-.5.5v5a.5.5,0,0,0,.5.5h5A.5.5,0,0,0,9,7.5v-5A.5.5,0,0,0,8.5,2Z",
    fill: "#0171cc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFuel);
export default __webpack_public_path__ + "static/media/Icon_Fuel.55bb5c570f6c01ad1b76b26af9ed2278.svg";
export { ForwardRef as ReactComponent };